import { Alert, Form, Select,Input  } from 'antd';
import { InvoiceByEMailAddressType, InvoiceChannel } from '../../../models';

const { Option } = Select;

type InvoiceByEmailProps = {
    
    invoiceChannel: InvoiceChannel;
    invoiceByEMail: InvoiceByEMailAddressType;
    invoiceEmail:string;
    businessEmailHasValue:boolean;
    privateEmailHasValue:boolean;
   
};

export const InvoiceByEMail = ({
   invoiceChannel,
    invoiceByEMail,
    invoiceEmail,
    businessEmailHasValue,
        privateEmailHasValue,
   
}: InvoiceByEmailProps) => {
    const showEmailSelection = invoiceChannel===InvoiceChannel.EMail;
    const showIndividualEmail = invoiceByEMail === InvoiceByEMailAddressType.individualEmail;

    return (
        <>
            <h3>Rechnungen per E-Mail</h3>
            <p>
                Auf Wunsch stellen wir Ihnen Rechnungen und erste Zahlungserinnerungen per E-Mail zu. Allfällig nötige Mahnungen erhalten Sie immer per Briefpost an die gewählte Rechnungs- und Korrespondenzadresse.
            </p>
            

            <Form.Item rules={[{ required: true }]} label="Auf welchem Weg möchten Sie Rechnungen von der AGZ erhalten?" name="invoiceChannel">
                <Select>
                    <Option value={InvoiceChannel.Letter}>Brief</Option>
                    <Option  value={InvoiceChannel.EMail}>
                        E-Mail
                    </Option>
                    
                </Select>
            </Form.Item>
            { invoiceByEMail=== InvoiceByEMailAddressType.privateEmail && !privateEmailHasValue ? (
                            <Alert
                                banner
                                style={{ marginBottom: '15px' }}
                                message="Bitte geben Sie oben Ihre private E-Mail-Adresse an"
                                type="info"
                                showIcon
                            />
                        ) : null}
            
                        {invoiceByEMail === InvoiceByEMailAddressType.businessEmail && !businessEmailHasValue ? (
                            <Alert
                                banner
                                style={{ marginBottom: '15px' }}
                                message="Bitte geben Sie oben Ihre geschäftliche E-Mail-Adresse an"
                                type="info"
                                showIcon
                            />
                        ) : null}
            
            {showEmailSelection ? (<Form.Item rules={[{ required: true }]} label="Rechnung per E-Mail" name="sendInvoiceByEmail">
                <Select>
                    
                    <Option  value={InvoiceByEMailAddressType.businessEmail}>
                        An meine geschäftliche Mailadresse 
                    </Option>
                    <Option  value={InvoiceByEMailAddressType.privateEmail}>
                        An meine private Mailadresse
                    </Option>
                    <Option value={InvoiceByEMailAddressType.individualEmail}>
                        An eine andere Mailadresse, ausschliesslich für den Rechnungsversand 
                    </Option>
                </Select>
            </Form.Item> ): null}

             {showIndividualEmail ? (<Form.Item rules={[{ required: true }]} label="E-Mail Rechnung" name="invoiceEmail">
                <Input />
            </Form.Item>):null}
        </>
    );
};
